import { accountTransactionsRouteProps } from 'src/navigation/routeProps'
import { createBackgroundReducer } from 'src/redux/genericReducers'
import UsersFullPaginatedDataReducer, {
  Actions as UsersFullPaginatedDataActions,
  initialState as initialUsersFullPaginatedDataState,
  UsersFullPaginatedDataState,
} from 'src/redux/usersFullPaginatedData.reducer'

export type AccountTransactionsState = {
  usersFullPaginatedData: UsersFullPaginatedDataState
}

export const initialState: AccountTransactionsState = {
  usersFullPaginatedData: initialUsersFullPaginatedDataState,
}

export type Actions = UsersFullPaginatedDataActions

const CoreAccountTransactionsReducer = (
  state = initialState,
  action: Actions,
): AccountTransactionsState => ({
  usersFullPaginatedData: UsersFullPaginatedDataReducer(
    state.usersFullPaginatedData,
    action as UsersFullPaginatedDataActions,
  ),
})

const AccountTransactionsReducer = createBackgroundReducer(
  accountTransactionsRouteProps,
  initialState,
  CoreAccountTransactionsReducer,
)

export default AccountTransactionsReducer
